import { create } from "zustand"
import { persist } from "zustand/middleware"

// The tab each portal's docs nav last showed, so switching portals keeps both.
interface DocsTabStore {
	activeByPortal: Record<string, string>
	setActiveTab: (portalInstanceId: string | null, tabId: string | null) => void
}

export const portalTabKey = (portalInstanceId: string | null) =>
	portalInstanceId ?? "root"

export const useDocsTabStore = create<DocsTabStore>()(
	persist(
		(set) => ({
			activeByPortal: {},
			setActiveTab: (portalInstanceId, tabId) =>
				set((state) => {
					const key = portalTabKey(portalInstanceId)
					const next = { ...state.activeByPortal }
					if (tabId) next[key] = tabId
					else delete next[key]
					return { activeByPortal: next }
				}),
		}),
		{ name: "docs-tab-state" },
	),
)

// The header's add menu, the tab bar, the API reference page and docs settings open these dialogs.
interface DocsTabDialogs {
	isNewTabOpen: boolean
	isNewApiReferenceOpen: boolean
	/** The API reference whose settings dialog is open. */
	apiSettingsTabId: string | null
	setNewTabOpen: (open: boolean) => void
	setNewApiReferenceOpen: (open: boolean) => void
	setApiSettingsTabId: (tabId: string | null) => void
}

export const useDocsTabDialogs = create<DocsTabDialogs>()((set) => ({
	isNewTabOpen: false,
	isNewApiReferenceOpen: false,
	apiSettingsTabId: null,
	setNewTabOpen: (open) => set({ isNewTabOpen: open }),
	setNewApiReferenceOpen: (open) => set({ isNewApiReferenceOpen: open }),
	setApiSettingsTabId: (tabId) => set({ apiSettingsTabId: tabId }),
}))
